import { KeyValuePipe } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatOption } from '@angular/material/core';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { MatTooltip } from '@angular/material/tooltip';
import { DeviceTypeParameterConfigWithAvailableListAndParameter } from '@vectronic/util';

@Component({
  selector: 'vectronic-parameter-selection-config',
  templateUrl: './parameter-selection-config.component.html',
  styleUrls: ['./parameter-selection-config.component.scss'],
  imports: [
    MatFormField,
    MatLabel,
    MatSelect,
    MatOption,
    MatSuffix,
    MatIcon,
    MatTooltip,
    KeyValuePipe,
    MatIconButton,
  ],
})
export class ParameterSelectionConfigComponent {
  config = input<DeviceTypeParameterConfigWithAvailableListAndParameter>();
  value = input<string>();
  disabled = input(false);
  readonly = input<boolean>();
  resetToFactoryTooltip = input<string>();

  hideLabel = input<boolean>();
  hasClose = input(false);
  showInfo = input(true);
  hasDelete = input(true);
  hasUndo = input(false);
  showReset = input<boolean>();

  configClose = output();
  parameterChange = output<{
    config: DeviceTypeParameterConfigWithAvailableListAndParameter;
    value: string;
  }>();
  parameterUndo = output<DeviceTypeParameterConfigWithAvailableListAndParameter>();
  resetToFactory = output<DeviceTypeParameterConfigWithAvailableListAndParameter>();

  onSelectionChange(
    $event: MatSelectChange,
    config: DeviceTypeParameterConfigWithAvailableListAndParameter,
  ) {
    this.parameterChange.emit({ config, value: $event.value });
  }

  // eslint-disable-next-line sonarjs/cognitive-complexity
  get validEnumCoding() {
    const vvr = this.config().validValueRange ?? this.config().parameter.validValueRange;
    const validEnumCoding = { ...this.config().parameter.enumCoding };

    if (vvr.list) {
      for (const key in validEnumCoding) {
        if (!vvr.list.includes(+key)) delete validEnumCoding[key];
      }
    }
    if (vvr.max != null) {
      for (const key in validEnumCoding) {
        if (+key > vvr.max) delete validEnumCoding[key];
      }
    }
    if (vvr.min != null) {
      for (const key in validEnumCoding) {
        if (+key < vvr.min) delete validEnumCoding[key];
      }
    }
    return validEnumCoding;
  }

  onClickRemove() {
    this.parameterChange.emit({ config: this.config(), value: undefined });
  }

  get parameterTitle() {
    const { name, subcategory } = this.config().parameter;
    if (subcategory) return `${subcategory} / ${name}`;
    else return name;
  }

  onClickClose() {
    this.configClose.emit();
  }

  onClickUndo() {
    this.parameterUndo.emit(this.config());
  }

  onResetToFactory() {
    this.resetToFactory.emit(this.config());
  }
}
